/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FadeLoader } from 'react-spinners';

import { loadStripe } from '@stripe/stripe-js'
import error from '../assets/error.png'
import success from '../assets/success.png'

import { update_event_details, update_event_details_deposit_only, update_event_details_balance, update_event_details_sellerPackage, 
    update_event_details_floorPlan, get_event_details } from '../store/reducers/eventDetailsReducer';

import { formatPhoneNumber } from 'react-phone-number-input';

import api from '../api/api';
import axios from 'axios';

import Header from '../components/Header';
import Footer from '../components/Footer';
import GetSellerConfig from '../components/GetSellerConfig';

import config from '../config';
const load = async () => {
    return await loadStripe(localStorage.getItem('stripePublishableKey'))
}

const ConfirmOrder = () => {
    const sellerBackendURL = config.STR_BACKEND_URL
    const arrCanvasSizes = config.STR_ARR_FLOOR_PLANNER_CANVAS_SIZES;
    const arrRoomSizes = config.STR_ARR_FLOOR_PLANNER_ROOM_SIZES;

    const { userInfo } = useSelector(state => state.auth) 
    const { seller } = useSelector(state => state.seller)

    const { 
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerColorDark, sellerColorMedium, sellerColorLight,
    } = GetSellerConfig();

    let orderId = null
    
    const customerId = userInfo.id
    const customerName = userInfo.name
    const customerEmail = userInfo.email
    const customerPhone = formatPhoneNumber(userInfo.phoneNumber)
        
    const strIsDeposit = localStorage.getItem('isDeposit')
    const strIsBalance = localStorage.getItem('isBalance')
    const boolIsDeposit = strIsDeposit === 'true' ? true : false
    const boolIsBalance = strIsBalance === 'true' ? true : false

    // console.log('update_payment isDeposit \n', boolIsDeposit)
    // console.log(`strIsDeposit is a ${typeof strIsDeposit}:`, strIsDeposit);
    // console.log(`boolIsDeposit is a ${typeof boolIsDeposit}:`, boolIsDeposit);

    //const orderType2 = boolIsDeposit  ? 'Deposit' : 'Menu Order' //=== 'true'

    let orderType = ''
    if (boolIsDeposit) {
        orderType = 'Deposit';
    } else if (boolIsBalance) {
        orderType = 'Balance';
    } else {
        orderType = 'Menu Order';
    }
    
    //console.log('update_payment orderType \n', orderType)

    const price = localStorage.getItem('price')
    const products = JSON.parse(localStorage.getItem('products'))
    const eventDetailsInfo = JSON.parse(localStorage.getItem('eventDetailsInfo'))
    // console.log('price ', price, '\nproducts ', products, '\neventDetailsInfo ', eventDetailsInfo)
    // console.log('ConfirmOrder products ', products) //works

    const sellerBoolShowSitePayments = seller.isVisibleSitePayments === 'Show' ? true : false

    const [loader, setLoader] = useState(true)
    const [stripe, setStripe] = useState('')
    const [message, setMessage] = useState(null)
    const dispatch = useDispatch()
    const navigate = useNavigate()
            
    const redirect_customerDashboard_myOrders_page = () => {
        localStorage.removeItem('isDeposit')
        localStorage.removeItem('isBalance')
        localStorage.removeItem('price')
        localStorage.removeItem('products')
        localStorage.removeItem('eventDetailsInfo')
        localStorage.removeItem('stripePublishableKey')
        
        navigate('/customerDashboard/myOrders')
    }

    useEffect(() => {
        if (!stripe) {
            return
        }
        const clientSecret = new URLSearchParams(window.location.search).get('payment_intent_client_secret')
        if (!clientSecret) {
            return
        }
        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
            switch(paymentIntent.status){
                case "succeeded":
                    setMessage('succeeded')
                    break
                    case "processing":
                    setMessage('processing')
                    break
                    case "requires_payment_method":
                    setMessage('failed')
                    break
                    default:
                    setMessage('failed')
            }
        })
    },[stripe])

    const get_load = async () => {
        const tempStripe = await load()
        setStripe(tempStripe)
    }

    useEffect(() => {
        get_load()
    },[])

    const get_customer_latest_orderId = async (customerId) => {
        // console.log('ConfirmOrder get_customer_latest_order_local price \n', price)
        // console.log('ConfirmOrder get_customer_latest_order_local products \n', products)
        // console.log('ConfirmOrder get_customer_latest_order_local eventDetailsInfo \n', eventDetailsInfo)

        let orderIdLocal = null
        try {
            const {data} = await api.get(`/home/customer/get-customer-latest-order/${customerId}`) 
            // console.log('get_customer_latest_order_local data.myOrder orderId \n', data.myOrder[0]._id)
            // orderId = data.myOrder[0]._id
            orderIdLocal = data.myOrder[0]._id
            // console.log('ConfirmOrder get_customer_latest_order_local orderId \n', data.myOrder[0]._id)
            // localStorage.setItem('orderId', data.myOrder[0]._id)
        } catch (error) {
            //return rejectWithValue(error.response.data)
        }
        return orderIdLocal
    }
    const place_order_local = async () =>{
        let orderIdLocal = null
        try {
            const { data } = await api.post('/home/order/place-order',{
                customerId, customerName, customerEmail, customerPhone, orderType, 
                price, products, eventDetailsInfo})
            orderIdLocal = data.orderId
        } catch (error) {
            
        }
        return orderIdLocal
    }
    
    //     export const place_order = createAsyncThunk(
    //     'order/place_order',
    //     async({customerId, customerName, customerEmail, customerPhone, 
    //         price, products, eventDetailsInfo }) => {
    //         // items, isDeposit, stripePublishableKey, sellerBoolShowPayments
    //         // backend const {customerId, customerName, customerEmail, customerPhone, 
    //         // price, products, eventDetailsInfo} = req.body
    //         try {
    //            const { data } = await api.post('/home/order/place-order',{
    //                 customerId, customerName, customerEmail, customerPhone, 
    //                 price, products, eventDetailsInfo})
    //             //orderId: data.orderId
    //             //console.log(eventDetailsInfo)
    //             //console.log(data)            
    //         } catch (error) {
    //             console.log(error.response)
    //         }
    //     }
    // )
    const update_payment = async () => {

        //  dispatch(place_order({
        //             customerId: userInfo.id, customerName: userInfo.name, customerEmail:userInfo.email, customerPhone: userInfo.phoneNumber,
        //             price, products, eventDetailsInfo : state 
        //         }))

        orderId = await place_order_local({
            customerId: userInfo.id, customerName: userInfo.name, customerEmail:userInfo.email, 
            customerPhone: formatPhoneNumber(userInfo.phoneNumber), price, products, eventDetailsInfo : eventDetailsInfo
        })

        //const customerId = userInfo.id
        //console.log('userInfo \n', userInfo)
        //orderId = await get_customer_latest_orderId(customerId)
        
        //console.log('update_payment isDeposit \n', isDeposit)
        //localStorage.removeItem
        if (userInfo) {
            //console.log('update_payment isDeposit \n', isDeposit) === 'true'
            if (boolIsDeposit) {
                dispatch(update_event_details_deposit_only({
                    customerId: userInfo.id,
                    depositGiven: boolIsDeposit, // , //false,
                    depositAmountPaid: price
                }))
            }
            if (boolIsBalance) {
                dispatch(update_event_details_balance({
                    customerId: userInfo.id,
                    balanceGiven: boolIsBalance, // , //false,
                    balanceAmountPaid: price
                }))
            }
            
            //if (!isDeposit || isDeposit === 'false') {
            if (!boolIsDeposit) {
                dispatch(update_event_details_deposit_only({
                    customerId: userInfo.id,
                    depositGiven: boolIsDeposit, // , //false,
                    depositAmountPaid: 0
                }))
                dispatch(update_event_details({
                    customerId: userInfo.id,
                    depositGiven: boolIsDeposit,
                    eventName: '', 
                    venueName: '', 
                    venueAddress: '',
                    eventType: '', 
                    eventDate: '', 
                    eventStartTime: '',
                    eventServiceType: '', 
                    eventPlaceSettings: '', 
                    eventGuestTableclothColor: '', 
                    eventBuffetTableclothColor: '',
                    eventNapkinColor: '',
                    venueManagerContactInfo: '', 
                    venueDoorCode: '',
                    eventGuestCount: 0, 
                    eventNotes: '',
                    customMenuProducts: '[]',
                    customMenuInstructions: '',
                    selectedGalleryImages: '[]',
                    otherEventOptions: '[]',
                    eventDetailsSellerNotes: '',
                    tableRequirements: '[]',
                    utensilsAndEquipmentList: '[]',
                    eventStaffList: '[]',
                    invoice: '[]',
                    eventPartsTimeLine: '[]',
                    coupon: '', 
                    couponDescription: '', 
                    couponExpirationDate: '',
                })) 

                dispatch(update_event_details_sellerPackage({
                    customerId: userInfo.id,
                    title: 'None'
                }))
                
                dispatch(update_event_details_floorPlan({
                    customerId: userInfo.id,
                    floorPlan: '',
                    floorPlanNotes: '',
                    floorPlanCanvasHeight: arrCanvasSizes[0],
                    floorPlanCanvasWidth: arrCanvasSizes[2],
                    floorPlanRoomHeight: arrRoomSizes[0],
                    floorPlanRoomWidth: arrRoomSizes[0], 
                }))
            } //end if (isDeposit === 'false') {    
        }
            
        if (orderId) {
            //console.log('ConfirmOrder confirm order orderId \n', orderId)
            try {
                //const { data } = await axios.post(`${localHostName}/api/order/create-payment`, {price}, {withCredentials:true})
                //await axios.get(`http://localhost:5000/api/order/confirm/${orderId}`)
                // backend orderController.order_confirm
                await axios.get(`${sellerBackendURL}/api/order/confirm/${orderId}`)

                //localStorage.removeItem('orderId')

                //localStorage.removeItem('isDeposit')
                
                setLoader(false)
            } catch (error) {
                console.log(error.response.data)
            }
        }
    }

    useEffect(() => {
        if (message === 'succeeded') {
            //alert('update_payment new')
            update_payment()
        }
    },[message])
    
    return (
        <div>
            <Header/>
                { /*w-screen h-screen*/ }
                <div className="w-full mt-0" style={{ backgroundColor: sellerComponentBackgroundColor }}>
                    <div className='rounded-2xl w-[85%] lg:w-[90%] md:w-[90%] sm:w-[95%] mx-auto bg-white'>
                        <div className='rounded-2xl w-full flex flex-wrap justify-center items-center 
                            flex-col gap-6 relative border p-5'
                            style={{ 
                                backgroundColor: sellerColorLight,
                                borderColor: sellerColorDark 
                            }}>
                            <div className='flex justify-center items-center flex-col gap-4'>
                            {
                                (message === 'failed' || message === 'processing') ? <>
                                <img src={error} alt="" />
                                <button onClick={redirect_customerDashboard_myOrders_page} 
                                    className='px-5 py-2 mt-2 border-2 rounded-lg cursor-pointer text-white' 
                                    style={{
                                        color: sellerColorDark, 
                                        backgroundColor: sellerColorLight, 
                                        borderColor: sellerColorDark
                                    }}>
                                    Back To Customer Dashboard
                                </button>
                                </> : message === 'succeeded' ? loader ? <FadeLoader/> : <>
                                <img src={success} alt=" m-4" />
                                <div className='font-semibold' style={{color: sellerColorDark}}>Your Payment Was Successful</div>
                                <button onClick={redirect_customerDashboard_myOrders_page}  
                                    className='px-5 py-2 mt-2 border-2 cursor-pointer rounded-xl text-white' 
                                    style={{
                                        color: sellerColorDark, 
                                        backgroundColor: sellerColorLight, 
                                        borderColor: sellerColorDark
                                    }}>
                                    Back To Customer Dashboard
                                </button>
                                </> : <FadeLoader/> 
                            }
                            </div>
                        </div>
                    </div>
                </div>
            <Footer/>
        </div>
        
    );
};

export default ConfirmOrder;





